import styled from '@emotion/styled'
import { css } from '@emotion/react'

const closedStyles = ({ theme, isOpen, isButtonVisible }) =>
  !isOpen &&
  isButtonVisible &&
  css`
    &::before {
      background: linear-gradient(
        to bottom,
        transparent 0%,
        ${theme.colors.white} 100%
      );

      height: ${theme.spacings.exa};

      transition: background ${theme.transition.leave} ease-in-out;

      pointer-events: none;
    }
  `

const contentStyles = ({ theme, isOpen, openHeight, closedHeight }) => css`
  label: content;

  min-height: 20px;
  height: ${isOpen ? openHeight : closedHeight}px;

  margin-bottom: ${theme.spacings.byte};

  overflow: hidden;

  transition: height .5s ease-in-out;
  will-change: height;

  position: relative;

  & > div {
    display: inline-block;
    width: 100%;
  }

  &::before {
    content: ' ';

    bottom: 0;

    position: absolute;

    width: 100%;

    z-index: 1;
  }
`

const floatButtonStyles = ({ theme }) => css`
  label: float-button;

  position: fixed;
  bottom: 40px;
  right: 50%;
  transform: translateX(50%);
  z-index: 2;

  border-radius: ${theme.borderRadius.giga};
  background: ${theme.colors.white};
  box-shadow: 0 0 0 1px ${theme.colors.shadow},
    0 ${theme.spacings.bit} ${theme.spacings.bit} 0 ${theme.colors.shadow},
    0 ${theme.spacings.byte} ${theme.spacings.byte} 0 ${theme.colors.shadow};
`

const buttonWrapperStyles = ({ theme }) => css`
  label: custom-button;

  display: flex;
  justify-content: flex-end;
`
export const Content = styled('div')(contentStyles, closedStyles)
export const ButtonWrapper = styled('div')(buttonWrapperStyles)
export const FloatButton = styled('div')(floatButtonStyles)
